// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1465":"dbc56ede5a512009","7240":"b69c26312223b654","9728":"556544d70cba3eff"}[chunkId] + ".js";
};